import React from "react";
import {SwitcherChildBlocks} from "./SwitcherChildBlocks";
import {SWITCH_DISPLAY_PERIOD_MARKETS} from "../../store/spirs/actions";
import { useDispatch, useSelector } from 'react-redux';
import {useTranslation} from "react-i18next";
import {TreeDirectory} from "../tree/Tree";
import { StoreType } from '../../store/spirs/types';
import { makeSelectTree } from '../VerticalMenu/selectors';


export const Rating = React.memo(() => {
    const mode = 'NOT_STARTED';
    const dispatch = useDispatch();
    const selectorTree = React.useMemo(makeSelectTree, []);
    const tree = useSelector((state: StoreType) => selectorTree(state));
    const {t} = useTranslation();

    React.useEffect(() => {
        return () => {
            dispatch(SWITCH_DISPLAY_PERIOD_MARKETS(false));
        }
    }, []);

    return (
        <>
            <div className="flex justify-between items-center bg-[#171A1E] rounded-[8px] pl-[16px] pr-[8px] mb-[16px] h-[48px]">
                <div className="text-[20px] text-[#EACD40]">
                    {t("verticalMenuItems.Rating")}
                </div>
                <div className="max-tablet:hidden">
                    <SwitcherChildBlocks/>
                </div>
            </div>
            <div className="tablet:hidden">
                <SwitcherChildBlocks/>
            </div>
            {tree.l.length <= 0 && (
                <div className={'text-center'}>
                    {t("fixture.noDataByFilter")}
                </div>
            )}
            <TreeDirectory tree={tree} mode={mode} fullHeight={false}/>
        </>
    )
}, () => true);
